import type { VoidFunctionComponent } from 'react';

import SelectAllProjectsCheckbox from './SelectAllProjectsCheckbox';
import SortingDropdown from './SortingDropdown';
import {
  createIssuesDropdownConfig,
  createRevisionDropdownConfig,
  createTitleDropdownConfig,
} from './sortingDropdownConfigs';

const ProjectsTableHeader: VoidFunctionComponent = () => {
  return (
    <div className="projects-table__header">
      <div>
        <SelectAllProjectsCheckbox />
      </div>
      <SortingDropdown config={createTitleDropdownConfig()} />
      <SortingDropdown config={createIssuesDropdownConfig()} />
      <SortingDropdown config={createRevisionDropdownConfig()} />
    </div>
  );
};

export default ProjectsTableHeader;
